/**
 * Header
 */

export default function Header() {
    const selectors = {
        'header' : '#header',
    };

    let lastScrollTop = 0;
    const searchBtn = jQuery('.search-btn');
    const searchFormDesktop = jQuery('.search-form.desktop');
    const searchInput = jQuery('.search-input');
    const hamburgerBtn = jQuery('.hamburger-menu');
    const closeMenuMobileBtn = jQuery('.close-menu-btn');
    const toggleSubMenuBtn = jQuery('.js-toggle-sub-menu');
    const triggerSubMenuBtn = jQuery('.trigger-sub-menu > a');
    const toggleSubMenuSecondBtn = jQuery('.second-level-menu .js-toggle-sub-menu');
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    this.init = () => {
        this.toggleFixedMenuOnScroll();
        this.handleSearchFormToggle();
        this.toggleMenuMobile();
        this.subMenuSecondHandle();
    };

    this.toggleFixedMenuOnScroll = () => {
        jQuery(window).on('scroll', function (event) {
            event.preventDefault();

            const scroll = jQuery(window).scrollTop();

            if (scroll > jQuery(selectors.header).height()) {
                jQuery('body').addClass('menu-fixed');
            } else {
                jQuery('body').removeClass('menu-fixed');
            }
        });
    }

    this.handleSearchFormToggle = () => {
        jQuery(selectors.header).on('click', searchBtn, function (e) {
            if (searchFormDesktop.css('display') === 'none') {
                searchFormDesktop.show();
                searchInput.focus();
            }
        });

        jQuery(selectors.header).on('click', '.js-close-search-btn', function () {
            searchFormDesktop.hide()
        });

        jQuery(document).on('click', function (e) {
            if (searchBtn.is(e.target) || searchInput.is(e.target)) {
                return;
            }
            searchFormDesktop.hide()
        });
    }

    this.toggleMenuMobile = () => {
        hamburgerBtn.on('click', function () {
            jQuery('body').toggleClass('open-menu');
        });

        closeMenuMobileBtn.on('click', function () {
            jQuery('body').removeClass('open-menu');
        });

        toggleSubMenuBtn.on('click', function () {
            jQuery(this).parent().toggleClass('active');
            jQuery(this).closest('ul').toggleClass('open-sub-menu');
        });

        if (isMobile) {
            triggerSubMenuBtn.on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                jQuery(this).parent().toggleClass('active');
                jQuery(this).closest('ul').toggleClass('open-sub-menu');
            });
        }
    }

    this.subMenuSecondHandle = () => {
        jQuery(toggleSubMenuSecondBtn).on('click', function () {
            const $this = jQuery(this);

            if ($this.hasClass('active')) {
                $this.removeClass('active').parent().find('.sub-menu').hide();
            } else {
                toggleSubMenuSecondBtn.removeClass('active').parent().find('.sub-menu').hide();
                $this.addClass('active').parent().find('.sub-menu').show();
            }
        });
    };

}
